const normalizeTimestamp = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed < 1e12 ? parsed * 1000 : parsed;
};

export const getDashboardStatusVersion = (status) => (
  normalizeTimestamp(status?.serverTime)
  ?? normalizeTimestamp(status?.receivedAt)
  ?? normalizeTimestamp(status?.mixerTrackStartTime)
  ?? normalizeTimestamp(status?.trackStartTime)
);

export const mergeDashboardStatusSnapshot = (
  currentStatus,
  snapshot,
  { requestStartedAt = 0, socketUpdatedAt = {} } = {}
) => {
  const current = currentStatus && typeof currentStatus === 'object' ? currentStatus : {};
  const incoming = snapshot && typeof snapshot === 'object' ? snapshot : {};
  const next = { ...current };

  Object.entries(incoming).forEach(([stationId, stationStatus]) => {
    // A socket event that arrived while this request was in flight is more
    // current than the response, even when the response came from a cache.
    if (Number(socketUpdatedAt[stationId]) > requestStartedAt) return;

    const currentVersion = getDashboardStatusVersion(current[stationId]);
    const incomingVersion = getDashboardStatusVersion(stationStatus);
    if (
      currentVersion !== null
      && incomingVersion !== null
      && incomingVersion < currentVersion
    ) {
      return;
    }

    next[stationId] = stationStatus;
  });

  return next;
};
